/* eslint-disable sort-keys */
export const selectWrapper = {
    position: 'relative',
    svg: {
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%) translateY(-2px)',
        pointerEvents: 'none',
    },
}
